<template>
    <flex-container>
        <text-decorator
            :size="FontSize.md"
            :color="Color.gray400"
            bold
        >
            {{ contact.name.fullName }}
        </text-decorator>
    </flex-container>
</template>

<script setup lang="ts">
    import useClient from '@composables/useClient';
    import { reactive } from 'vue';
    import { Contact } from '@keyvue/one-api-client';
    import { FlexContainer, TextDecorator, FontSize, Color } from '@keyvue/one-ui';

    interface Props {
        contactId: string;
    }

    const props = defineProps<Props>();

    const { client } = useClient();

    const contact = reactive(await client.get(Contact, props.contactId)) as Contact;
</script>
